"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDemandContractFormData = exports.generateSalesforceOpportunityUrl = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const demand_contracts_1 = require("../../demand-contracts");
const fake_sub_account_1 = require("../fake-sub-account");
const fake_demand_platform_fee_config_1 = require("./fake-demand-platform-fee-config");
const fake_revenue_clause_1 = require("./fake-revenue-clause");
faker_1.default.seed(718);
const generateSalesforceOpportunityUrl = () => {
    const id = faker_1.default.random.alphaNumeric(18);
    return `https://enginebymoneylion.lightning.force.com/lightning/r/Opportunity/${id}/view`;
};
exports.generateSalesforceOpportunityUrl = generateSalesforceOpportunityUrl;
const generateDemandContractFormData = (revenueClauseType, isDemandReceivablesEnabled) => {
    const demandPlatformFeeConfigType = demand_contracts_1.RevenueClauseTypeToConfigType[revenueClauseType];
    const supplySubAccounts = (0, fake_sub_account_1.generateFakeSupplySubAccount)();
    const demandSubAccount = (0, fake_sub_account_1.generateFakeDemandSubAccount)();
    return {
        demandPlatformFeeConfig: (0, fake_demand_platform_fee_config_1.generateDemandPlatformFeeConfig)(demandPlatformFeeConfigType, isDemandReceivablesEnabled),
        effectiveAt: faker_1.default.date
            .between('2024-01-01', '2024-12-31')
            .toISOString()
            .split('T')[0],
        revenueClauses: [(0, fake_revenue_clause_1.generateRevenueClause)(revenueClauseType)],
        salesforceOpportunityIdOrUrl: (0, exports.generateSalesforceOpportunityUrl)(),
        selectedDemandSubAccount: demandSubAccount,
        subAccount: supplySubAccounts[0],
        subAccountUuid: demandSubAccount.uuid,
    };
};
exports.generateDemandContractFormData = generateDemandContractFormData;
